module.exports = __webpack_public_path__ + "static2023-4-17/img/get.3aca7b2c.png";